import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DailygridsColumns } from 'src/app/shared/model/dailygrids-column';
import { FeedService } from 'src/app/shared/service/feed.service';
import { UtilService } from 'src/app/shared/service/util.service';

@Component({
  selector: 'app-modify-columns-dialog',
  templateUrl: './modify-columns-dialog.component.html',
  styleUrls: ['./modify-columns-dialog.component.css']
})
export class ModifyColumnsDialogComponent implements OnInit {
  columnsForm: FormGroup;
  isEditing: boolean;
  isLoading: boolean;

  constructor(
    public dialogRef: MatDialogRef<ModifyColumnsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { column: DailygridsColumns, isEditing: boolean },
    private fb: FormBuilder,
    private translateService: TranslateService,
    private utilService: UtilService,
    private feedService: FeedService,
    private snackBar: MatSnackBar,
    private translate: TranslateService


  ) {
    this.columnsForm = this.fb.group({
      columnName: ['', Validators.required],
      field: ['', Validators.required],

    });
    this.isEditing = data.isEditing;
  }

  ngOnInit(): void {
    this.isLoading = false;
    if (this.isEditing && this.data.column) {
      this.columnsForm.setValue({
        columnName: this.data.column.columnName,
        field: this.data.column.field,

      });
    }
  }

  async onSave() {


    if (this.columnsForm.valid) {
      let textConfirm = this.isEditing
        ? await this.translateService.get('epg.users.dialog.messageEditConfirm').toPromise()
        : await this.translateService.get('epg.users.dialog.messageAddConfirm').toPromise();

      let buttonConfirm = this.isEditing
        ? await this.translateService.get('epg.users.dialog.buttons.edit').toPromise()
        : await this.translateService.get('epg.users.dialog.buttons.add').toPromise();

      const dialogRef = this.utilService.openConfirmDialog({
        title: buttonConfirm,
        text: textConfirm,
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isLoading = true;

          var newColumn: DailygridsColumns = {
            columnName: this.columnsForm.value.columnName,
            field: this.columnsForm.value.field
          }
          if (this.isEditing) {
            this.feedService.updateDailygridsColumn(this.data.column.id, newColumn).subscribe({
              next: (response) => {
                this.isLoading = false;
                this.translate.get("epg.configurationDailyColumns.snackbarSuccessSave").subscribe((message) => {
                  this.snackBar.open(message, "X", {
                    duration: 3000,
                    panelClass: ["SuccessfulSnackbar"],
                  });
                  this.dialogRef.close(true); 

                });
              },
              error: (error) => {
                this.isLoading = false;
                console.error('Error al guardar los cambios:', error);
                this.translate.get("epg.configurationDailyColumns.snackbarErrorSave").subscribe((message) => {
                  this.snackBar.open(message, "X", {
                    duration: 3000,
                    panelClass: ["error-snackbar"],

                  });
                });

              }
            }
            )
          } else {
            this.feedService.addDailygridsColumn(newColumn).subscribe({
              next: (response) => {
                this.isLoading = false;
                this.translate.get("epg.configurationDailyColumns.snackbarSuccessSave").subscribe((message) => {
                  this.snackBar.open(message, "X", {
                    duration: 3000,
                    panelClass: ["SuccessfulSnackbar"],
                  });
                  this.dialogRef.close(true);

                });
              },
              error: (error) => {
                this.isLoading = false;
                console.error('Error al guardar los cambios:', error);
                this.translate.get("epg.configurationDailyColumns.snackbarErrorSaveNew").subscribe((message) => {
                  this.snackBar.open(message, "X", {
                    duration: 3000,
                    panelClass: ["error-snackbar"],

                  });
                });

              }
            });
          }
        } else { 
          this.isLoading = false;
        }
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
